module.exports = __webpack_public_path__ + "static/media/16UNODC8.16b3d359.jpg";